import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Icon, Input, Checkbox, Tooltip, Select } from 'antd';
import {
  Container,
  SearchBar,
  TemplateTitleSec,
  ActiveContent,
  ContentType,
  ContentSection,
  FilterTitle,
  AdvSearchIcon,
  SearchButton,
  SearchTitle,
  EmptySettingsDetails,
} from './styles';
import { ScrollContainer, DesignModal, ModalBody, MenuDrawer } from '../LandingPage/styles';
import EmptyElementsIllustration from '../../images/empty-elements.svg';
import {
  getAllCategoriesByShortMessageTemplate,
  getAllDocumentsByCategories,
} from '../../utils/services/categoriesAPI';
import SideNav from '../LandingPage/SideNav';
import ReferenceElements from '../ReferenceElements';
import CreateTemplateModal from '../../components/CreateNewTemplate/CreateTemplateModal';
import CreateShortMsgTempModal from '../../components/CreateNewTemplate/CreateShortMsgTempModal';
import CreateMailTemplateModal from '../../components/CreateNewTemplate/CreateMailTemplateModal';
import CreateNewRefElement from '../../components/Modals/CreateNewRefElement';
import CreateFlowModal from '../../components/CreateNewTemplate/CreateFlowModal';
import CreateBlockModal from '../../components/CreateNewTemplate/CreateBlockModal';
 
import DocTemplateSection from './documentTemplates';
import MasterTempSection from './masterTemplates';
import EmailTemplateSection from './emailTemplates';
import PublishedTemplates from './publishedTemplates';
import { getAllBlockByCategories, getAllFlowByCategories, getEmailElementCateg } from '../../utils/services/elementAPI';
import { getAllMailTemplates } from '../../utils/services/mailTemplateAPI';
import AddTags from './tagSearch';

// app store context API
import { AppStoreContext } from '../../context/appStoreContext';
import ShortMessageTemplateSection from './shortMessageTemplates';
import { fetchPlanUsageDetails } from '../../utils/services/planUsage';
import UpgradePlanModal from '../../components/Modals/UpgradePlanModal';
import {
  DOCUMENT_TEMPLATES_LIST,
  EMAIL_TEMPLATES_LIST,
  SHORT_MESSAGE_TEMPLATES_LIST,
  ADVANCED_FILTER,
  DOCUMENT_AND_EMAIL_ELEMENTS_LIST,
  REUSABLE_PAGE_DESIGN,
  REUSABLE_SECTION_DESIGN
} from './translationValues';
import { CREATE_NEW_TEMPLATE_MODAL } from '../../components/CreateNewTemplate/translationValues';
import { withTranslation } from 'react-i18next';
import { ENABLE_EMAIL_DESIGNS, SUPPORT_EMAIL_ID } from '../../utils/helper';

import _ from 'underscore';
import GeneratePdf from './GeneratePdf';
import { getAllLanguage } from '../../utils/services/languageApi';
import { useSessionContext } from '../../context/sessionContext';
import SetupErrorModal from '../../components/Modals/SetupErrorModal';

const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const NAMESPACES = [
  'DOCUMENT_TEMPLATES_LIST',
  'EMAIL_TEMPLATES_LIST',
  'SHORT_MESSAGE_TEMPLATES_LIST',
  'ADVANCED_FILTER',
  'DOCUMENT_AND_EMAIL_ELEMENTS_LIST',
  'REUSABLE_PAGE_DESIGN',
  'REUSABLE_SECTION_DESIGN',
  'CREATE_NEW_TEMPLATE_MODAL',
];

const TemplateSection = props => {
  const { t } = props;
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [updateModalVisibility, setUpdateModalVisibility] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [categoryList, setCategoryList] = useState([]);
  const {
    isEnterprise,
    checkUserAccess,
    getTemplateList,
    setFetchingCategories,
    templatesList,
    totalTemplates,
    setTemplatesList,
    checkUserAccessRoles,
  } = useContext(AppStoreContext);
  const [filterCateg, setFilterCateg] = useState(null);
  const [searchedValue, setSearchedValue] = useState('');
  const [searchedTagValue, setSearchedTagValue] = useState(null);
  const [globalSearchVal, setGlobalSearch] = useState(null);
  const [globalSearchTag, setGlobalSearchTag] = useState(null);
  const [userpage, setuserpage] = useState(1);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [drawAnimate, setDrawAnimate] = useState(false);
  const [showSearchIcon, setShowSearchIcon] = useState(false);
  const [forApproval, setForApproval] = useState(false);
  const [activeContent, setActiveContent] = useState(undefined);
  const [elementmodalVisibility, setElementmodalVisibility] = useState(false);
  const [isScrollToTop, setIsScrollToTop] = useState(false);
  const [checkBoxOptions, setCheckBoxOptions] = useState([]);
  const [modalCheckBoxOptions, setModalCheckBoxOptions] = useState([]);
  const [isClearALLInputs, setIsClearALLInputs] = useState(false);
  const [fetchingCategoryList, setFetchingCategoryList] = useState(true);
  const [isTemplateDeleted, setIsTemplateDeleted] = useState(false);
  const [isTypeSwitched, setIsTypeSwitched] = useState(false);
  const [currentUploadStep, setCurrentUploadStep] = useState(0);
  const [isCheckingLimit, setIsCheckingLimit] = useState(false);
  const [documentLimit, setDocumentLimit] = useState(null);
  const [planName, setPlanName] = useState('');
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [languageList, setLanguageList] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('all');
  const [showSetupFailureError, setShowSetupFailureError] = useState(false);  

  const history = useHistory();
  const isDocumentContent = props.location?.pathname === '/documentTemplates';
  const isEmailContent = props.location?.pathname === '/emailTemplates';
  const isMasterContent = props.location?.pathname === '/designInspirations';
  const isPublishedTemp = props.location?.pathname === '/publishedTemplates';
  const isShortMessageContent = props.location?.pathname === '/shortMessageTemplates';
  const isPublishedMessages =
    props.location?.pathname === '/publishedMessages' ||
    props.location?.pathname === '/publishedSMS' ||
    props.location?.pathname === '/publishedCallMessages';
  const isEmailPublishedTemp = props.location?.pathname === '/emailPublishedTemplates';
  const isPublishedList =
    props.location?.pathname === '/publishedTemplates' ||
    props.location?.pathname === '/publishedMessages' ||
    props.location?.pathname === '/emailPublishedTemplates' ||
    props.location?.pathname === '/publishedSMS' ||
    props.location?.pathname === '/publishedCallMessages';

  const organisationSelector = useCallback(store => store.organizationSetup, []);
  const [organizationSetup] = useSessionContext(organisationSelector);

  const isSaasSetupFailed = !isEnterprise && checkUserAccess('client') && organizationSetup !== 'completed';

  useEffect(() => {
    (async () => {
      setCategoryList([]);
      setSelectedLanguage('all');
      if (!isEmailContent && !isEmailPublishedTemp) {
        if (isShortMessageContent) {
          if (activeContent === 'sms' || activeContent === 'call' || activeContent === 'whatsapp') {
            let userCateogoryResp = await getAllCategoriesByShortMessageTemplate(
              false,
              false,
              isMasterContent
                ? 'mastertemplate'
                : checkUserAccess('client')
                ? 'usertemplate'
                : 'mastertemplate',
              false,
              'write',
            );
            if (userCateogoryResp && userCateogoryResp.data) {
              setCategoryList(userCateogoryResp.data);
            }
          }
        } else {
          if (activeContent === 'Docs') {
            let userCateogoryResp = await getAllDocumentsByCategories(
              false,
              false,
              isMasterContent
                ? 'mastertemplate'
                : checkUserAccess('client')
                ? 'usertemplate'
                : 'mastertemplate',
              false,
              'write',
            );
            if (userCateogoryResp && userCateogoryResp.data) {
              setCategoryList(userCateogoryResp.data);
            }
          } else if (activeContent === 'MasterMailDocs') {
            let categoryResp = await getAllMailTemplates(
              1,
              true,
              null,
              null,
              null,
              'master',
              8,
              'write',
            );
            if (categoryResp && categoryResp.data) {
              const elementByCteg = categoryResp.data.map(element => {
                return {
                  categoryId: element.id,
                  categoryName: element.name,
                };
              });
              setCategoryList(elementByCteg);
            }
          } else {
            let categoryResp;
            if(activeContent === 'createFlow')
              categoryResp = await getAllFlowByCategories();
            if(activeContent === 'createBlock')
              categoryResp = await getAllBlockByCategories();
            if (categoryResp) {
              let elementCategory;
              if (!isMasterContent && checkUserAccess('client')) {
                if(categoryResp.data !== null)
                elementCategory = categoryResp && categoryResp?.data?.filter(categoryObj => categoryObj.standaloneFlows || categoryObj.standaloneBlocks);
                else 
                elementCategory = [];
              } else {
                elementCategory = categoryResp?.data?.filter(
                  categoryObj => categoryObj.masterElements,
                );
              }
              setCategoryList(elementCategory);
            }
          }
        }
        setFetchingCategoryList(false);
      } else {
        if (activeContent === 'Docs') {
          let categoryResp = await getAllMailTemplates(1, true, null, null, null, null, 8, 'write');
          if (categoryResp && categoryResp.data) {
            const elementByCteg = categoryResp.data.map(element => {
              return {
                categoryId: element.id,
                categoryName: element.name,
              };
            });
            setCategoryList(elementByCteg);
          }
        } else {
          let categoryResp = await getEmailElementCateg(activeContent === 'Referenced');
          if (categoryResp) {
            const elementByCteg = categoryResp.data.map(element => {
              return {
                categoryId: element.id,
                categoryName: element.name,
              };
            });
            setCategoryList(elementByCteg);
          }
        }
        setFetchingCategoryList(false);
      }
    })();
    // eslint-disable-next-line
  }, [activeContent, isTypeSwitched]);

  useEffect(() => {
    if (categoryList && categoryList?.length > 0) {
      let allCategoryOptions = categoryList?.map(category => ({
        label: category.categoryName,
        value: category.categoryId,
      }));
      let categoryOptions = categoryList
        .slice(0, 5)
        .map(category => ({ label: category.categoryName, value: category.categoryId }));
      setModalCheckBoxOptions(allCategoryOptions);
      setCheckBoxOptions(categoryOptions);
    }
    // eslint-disable-next-line
  }, [categoryList]);

  useEffect(() => {
    document.querySelector('#scrollContainer').scrollTop = 0;
    setuserpage(1);
    clearAllFilters();
    setFetchingCategories(true);
    setTemplatesList([]);
    isShortMessageContent
      ? changeActiveContent('whatsapp', true)
      : !checkUserAccessRoles(['DESIGNER', 'PUBLISHER']) ? changeActiveContent('createFlow', true) : changeActiveContent('Docs', true);
    setIsTypeSwitched(!isTypeSwitched);
  }, [props.location?.pathname]);

  useEffect(() => {
    if (currentUploadStep > 0) {
      setShowDrawer(false);
    }
  }, [currentUploadStep]);

  useEffect(() => {
    if (isTemplateDeleted) {
      setIsTemplateDeleted(false);
    }
    setFetchingCategories(true);
    setuserpage(1);
    if (!isPublishedList) {
      getTemplateList(
        activeContent,
        isMasterContent,
        isEmailContent,
        isShortMessageContent,
        1,
        globalSearchVal,
        globalSearchTag,
        filterCateg,
        forApproval,
        () => {},
        selectedLanguage,
      );
    }
  }, [globalSearchVal, globalSearchTag, filterCateg, forApproval, isTemplateDeleted, selectedLanguage]);

  const changeActiveContent = (active, force = false) => {
    if (activeContent !== active || force) {
      setFetchingCategoryList(true);
      setuserpage(1);
      setActiveContent(active);
      clearAllFilters();
      setFetchingCategories(true);
      getTemplateList(active, isMasterContent, isEmailContent, isShortMessageContent, 1);
    }
  };

  const clearAllFilters = () => {
    setFilterCateg(null);
    setSearchedValue(null);
    setGlobalSearchTag(null);
    setIsClearALLInputs(!isClearALLInputs);
    setGlobalSearch(null);
    setForApproval(false);
    setSelectedLanguage('all');
  };

  const categoryChange = checkedValues => {
    setuserpage(1);
    let mergeFilterCateg = filterCateg ? [...filterCateg] : [];
    const optionLabels = checkBoxOptions.map(option => option.value);
    if (checkedValues.length > 0) {
      const uncheckedValues = optionLabels.filter(value => !checkedValues.includes(value));
      checkedValues.forEach(value => {
        if (!mergeFilterCateg.includes(value)) {
          mergeFilterCateg.push(value);
        }
      });
      mergeFilterCateg = mergeFilterCateg.filter(value => {
        return !uncheckedValues.includes(value);
      });
      setFilterCateg(mergeFilterCateg.length > 0 ? mergeFilterCateg : null);
    } else {
      mergeFilterCateg = mergeFilterCateg.filter(value => {
        return !optionLabels.includes(value);
      });
      setFilterCateg(mergeFilterCateg.length > 0 ? mergeFilterCateg : null);
    }
  };

  const onAllCategoryChange = checkedValues => {
    setuserpage(1);
    if (checkedValues.length > 0) {
      setFilterCateg(checkedValues);
    } else {
      setFilterCateg(null);
    }
  };

  const globalSearch = e => {
    setSearchedValue(e.target.value);
    if (e.target.value.length === 0) {
      setGlobalSearch(null);
    }
  };

  const globalTagSearch = e => {
    setSearchedTagValue(e);
    if (e.length === 0) {
      setGlobalSearchTag(null);
    } else {
      setuserpage(1);
      setGlobalSearchTag(e);
    }
  };

  const searchTemplateByTag = async () => {
    setuserpage(1);
    searchedTagValue && searchedTagValue?.length > 0 && setGlobalSearchTag(searchedTagValue);
  };
  const searchTemplate = async () => {
    setuserpage(1);
    setGlobalSearch(searchedValue);
  };

  const hideDraw = () => {
    setShowDrawer(false);
    setDrawAnimate(true);
    setShowSearchIcon(false);
    setTimeout(() => {
      setDrawAnimate(false);
    }, 1800);
  };
  const showDraw = () => {
    setShowDrawer(true);
    setTimeout(() => {
      setShowSearchIcon(true);
    }, 1000);
  };
  
  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await getAllLanguage();
        if(response.statusCode === 109) {
          setLanguageList(response?.data);
        }
      } catch (error) {
        console.error(error);
      }
      
    }
    fetchLanguages();
  }, []);

  const enableModalVisibility = async (actionType, template) => {
    if (actionType === 'create-template' || actionType === 'create-email-template' || actionType === 'createFlow' ) {
      setUpdateModalVisibility(true);
    } else {
      setElementmodalVisibility(true);
    }
    setSelectedAction(actionType);
    setSelectedTemplate(template);
  };

  const disableModalVisibility = () => {
    setUpdateModalVisibility(false);
    setElementmodalVisibility(false);
    setSelectedAction(null);
    setSelectedTemplate(null);
  };

  const redirectToTemplate = (template, ...rest) => {
    const isComplex = rest[0] === 'isComplex';
    if (isComplex) {
      history.push(`/design/${template?.documentId}`);
    } else {
      if (template.id) {
        history.push(`/design/${template.id}`);
      }
    }
  };

  const redirectToFlow =(id)=> {
    history.push(`/flow/${id}`);
  }
  const redirectToBlock = (id) =>{
    history.push(`/block/${id}`);
  }

  const redirectToShortMessageTemplate = template => {
    if (template.id) {
      history.push(`/shortMessageDesign/${template.id}`);
    }
  };

  const redirectToMailTemplate = template => {
    if (template.data?.mailTemplateId) {
      history.push(`/emailDesign/${template.data.mailTemplateId}`);
    }
  };

  const handleScroll = () => {
    let reference = document.querySelector('#scrollContainer');
    if (reference) {
      if (reference.classList.contains('on-scrollbar') === false) {
        reference.classList.add('on-scrollbar');
      } else {
        setTimeout(() => {
          if (document.querySelector('#scrollContainer')) {
            document.querySelector('#scrollContainer').classList.remove('on-scrollbar');
          }
        }, 500);
      }
      if (
        reference.scrollTop !== 0 &&
        (((reference.scrollHeight - 40) - reference.scrollTop - reference.clientHeight) <= 1)
      ) {
        if (
          !(
            activeContent === 'Docs' ||
            activeContent === 'MasterMailDocs' ||
            activeContent === 'whatsapp' ||
            activeContent === 'sms' ||
            activeContent === 'call'
          )
        ) {
          setuserpage(userpage + 1);
        } else if (isPublishedList) {
          setuserpage(userpage + 1);
        } else {
          if (templatesList.length < totalTemplates) {
            getTemplateList(
              activeContent,
              isMasterContent,
              isEmailContent,
              isShortMessageContent,
              userpage + 1,
              globalSearchVal,
              globalSearchTag,
              filterCateg,
              forApproval,
              () => {
                setuserpage(userpage + 1);
              },
              selectedLanguage,
            );
          }
        }
      }
      if (reference.scrollTop > 800) {
        setIsScrollToTop(true);
      } else {
        setIsScrollToTop(false);
      }
    }
  };

  const handleCreateDocTemplate = async () => {
    if(isSaasSetupFailed) {
      return setShowSetupFailureError(true);
    }
    if(isEnterprise || checkUserAccess('master')) {
      enableModalVisibility('create-template', null);
      return;
    }
    try {
      setIsCheckingLimit(true);
      const response = await fetchPlanUsageDetails();
      if(response?.statusCode === 1918) {
        const { templateLimit: created } = response.data.usage;
        const { templateLimit: limit, planName } = response.data.upperLimit;
        if (created >= limit) {
          setDocumentLimit(limit);
          setPlanName(planName);
          setShowUpgradeModal(true);
        } else {
          enableModalVisibility('create-template', null);
        }
      }
    }
    catch(e) {
      console.error(e);
    }
    finally {
      setIsCheckingLimit(false);
    }
  }

  const smoothScroll = () => {
    document.querySelector('#scrollContainer').scrollTop = 0;
  };

  return (
    <ScrollContainer
      onScroll={_.debounce(handleScroll, 500)}
      id="scrollContainer"
      uploadCurrent={currentUploadStep > 0}
      isUploadFile={isPublishedList}
    >  
      <SideNav />
      <Container isUploadFile={isPublishedList}>
        {isPublishedList && currentUploadStep > 0 ? (
          ''
        ) : (
          <Tooltip
            placement="left"
            title={
              !showDrawer &&
              t(
                `ADVANCED_FILTER:${ADVANCED_FILTER.ADVANCED_FILTER_TITLE.key}`,
                ADVANCED_FILTER.ADVANCED_FILTER_TITLE.value,
              )
            }
          >
            <AdvSearchIcon
              type={showDrawer ? 'close' : 'search'}
              showSearchIcon={showDrawer && showSearchIcon}
              onClick={() => (showDrawer ? hideDraw() : showDraw())}
            />
          </Tooltip>
        )}
        <DesignModal
          categ={true}
          title={
            <p>
              {t(
                `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.key}`,
                ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.value,
              )}
              <div className="badge">{categoryList?.length} </div>
            </p>
          }
          centered
          visible={showCategories}
          onOk={() => setShowCategories(false)}
          onCancel={() => setShowCategories(false)}
          footer={null}
          mask={false}
          className={'design_modal_categ'}
        >
          <ModalBody>
            <CheckboxGroup
              options={modalCheckBoxOptions}
              value={filterCateg}
              onChange={onAllCategoryChange}
            />
          </ModalBody>
        </DesignModal>
        <MenuDrawer
          SearchDrawer={true}
          className={showDrawer ? 'drawVisible' : drawAnimate ? 'drawAnimate' : 'drawInVisible'}
        >
          <div className={!showDrawer ? 'switch' : 'switch_searchBar'} />
          <div className="searchDrawer">
            {showDrawer && (
              <ContentSection>
                <SearchTitle>
                  {t(
                    `ADVANCED_FILTER:${ADVANCED_FILTER.ADVANCED_FILTER_TITLE.key}`,
                    ADVANCED_FILTER.ADVANCED_FILTER_TITLE.value,
                  )}
                </SearchTitle>
                <FilterTitle className={'clearFilter'} onClick={() => clearAllFilters()}>
                  {t(
                    `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_CLEAR_ALL.key}`,
                    ADVANCED_FILTER.FILTER_CLEAR_ALL.value,
                  )}
                </FilterTitle>
                <FilterTitle>
                  {' '}
                  {t(
                    `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_NAME_LABEL.key}`,
                    ADVANCED_FILTER.FILTER_BY_NAME_LABEL.value,
                  )}
                </FilterTitle>
                <SearchBar className={'focused'}>
                  <Input
                    autoComplete="off"
                    name="nameSearch"
                    placeholder={t(
                      `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_NAME_PLACEHOLDER.key}`,
                      ADVANCED_FILTER.FILTER_BY_NAME_PLACEHOLDER.value,
                    )}
                    onChange={e => globalSearch(e)}
                    allowClear
                    value={searchedValue}
                    onPressEnter={() => searchTemplate()}
                  />
                </SearchBar>
                <FilterTitle>
                  {t(
                    `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.key}`,
                    ADVANCED_FILTER.FILTER_BY_CATEGORY_LABEL.value,
                  )}
                </FilterTitle>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  {fetchingCategoryList ? (
                    <Icon type="loading" />
                  ) : categoryList.length > 0 ? (
                    <>
                      <CheckboxGroup
                        options={checkBoxOptions}
                        value={filterCateg}
                        onChange={categoryChange}
                      />
                      {categoryList.length > 5 && (
                        <div
                          onClick={() => setShowCategories(true)}
                          style={{
                            fontFamily: 'Raleway,sans-serif',
                            fontSize: '15px',
                            fontWeight: 700,
                            marginTop: '10px',
                            cursor: 'pointer',
                            color: 'rgb(219,57,31) ',
                          }}
                        >
                          {`+${categoryList.length - 5}` +
                            t(
                              `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_SHOW_ALL_CATEGORIES_ACTION.key}`,
                              ADVANCED_FILTER.FILTER_SHOW_ALL_CATEGORIES_ACTION.value,
                            )}
                        </div>
                      )}
                    </>
                  ) : (
                    <EmptySettingsDetails>
                      <div className="empty-illustration">
                        <img src={EmptyElementsIllustration} alt="EmptyElementsIllustration" />
                      </div>
                      <div className="empty-txt" style={{ color: '#fff' }}>
                        <span>
                          {t(
                            `ADVANCED_FILTER:${ADVANCED_FILTER.EMPTY_CATEGORIES_LIST.key}`,
                            ADVANCED_FILTER.EMPTY_CATEGORIES_LIST.value,
                          )}
                        </span>
                      </div>
                    </EmptySettingsDetails>
                  )}
                </div>
                {!isMasterContent && (activeContent === 'Docs' || activeContent === 'createFlow' || activeContent === 'createBlock') && !isPublishedList && (
                  <>
                    <FilterTitle>
                      {t(
                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_STATUS_LABEL.key}`,
                        ADVANCED_FILTER.FILTER_BY_STATUS_LABEL.value,
                      )}
                    </FilterTitle>
                    <Checkbox
                      onChange={() => {
                        setForApproval(!forApproval);
                        setuserpage(1);
                      }}
                      checked={forApproval}
                    >
                      {t(
                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_WAITING_FOR_APPROVAL_LABEL.key}`,
                        ADVANCED_FILTER.FILTER_WAITING_FOR_APPROVAL_LABEL.value,
                      )}
                    </Checkbox>
                  </>
                )}
                {!isMasterContent && (
                  <>
                    <FilterTitle>
                      {t(
                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_TAGS_LABEL.key}`,
                        ADVANCED_FILTER.FILTER_BY_TAGS_LABEL.value,
                      )}
                    </FilterTitle>
                    <AddTags
                      globalTagSearch={e => globalTagSearch(e)}
                      clearALLTags={isClearALLInputs}
                      checked={globalSearchTag}
                      placeholder={t(
                        `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_BY_TAGS_PLACEHOLDER.key}`,
                        ADVANCED_FILTER.FILTER_BY_TAGS_PLACEHOLDER.value,
                      )}
                    />
                  </>
                )}
                {!isMasterContent && !isPublishedList && (activeContent === 'Docs' || activeContent === 'whatsapp' || activeContent === 'sms' || activeContent === 'call') && (
                  <>
                    <FilterTitle>
                      {t(ADVANCED_FILTER.LANGUAGE_FILTER_LABEL.key, ADVANCED_FILTER.LANGUAGE_FILTER_LABEL.value)}
                    </FilterTitle>
                    <Select
                      showSearch
                      style={{ width: '100%', fontFamily: 'Raleway' }}
                      optionFilterProp="children"
                      onChange={(e) => setSelectedLanguage(e)}
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      value={selectedLanguage}
                    >
                      <Option value='all' selected>{t(ADVANCED_FILTER.ALL_OPTION.key, ADVANCED_FILTER.ALL_OPTION.value)}</Option>
                      {languageList.map((item) => {
                        return <Option value={item.code}>{item.name}</Option>
                      })}
                    </Select>
                  </>
                )}
                <div className="button">
                  <SearchButton
                    onClick={() => {
                      searchTemplate();
                      searchTemplateByTag();
                    }}
                  >
                    {t(
                      `ADVANCED_FILTER:${ADVANCED_FILTER.FILTER_SEARCH_BUTTON.key}`,
                      ADVANCED_FILTER.FILTER_SEARCH_BUTTON.value,
                    )}
                  </SearchButton>
                </div>
              </ContentSection>
            )}
          </div>
        </MenuDrawer>
        {!isPublishedList && (
          <TemplateTitleSec isPublishedTemp={isPublishedList}>
            <p className={'template_title'}>
              {isMasterContent
                ? t(
                    DOCUMENT_TEMPLATES_LIST.DESIGN_INSPIRATION_TITLE.key,
                    DOCUMENT_TEMPLATES_LIST.DESIGN_INSPIRATION_TITLE.value,
                  )
                : isEmailContent
                ? t(
                    `EMAIL_TEMPLATES_LIST:${EMAIL_TEMPLATES_LIST.EMAIL_TITLE.key}`,
                    EMAIL_TEMPLATES_LIST.EMAIL_TITLE.value,
                  )
                : isPublishedList
                ? ''
                : isShortMessageContent
                ? t(
                    `SHORT_MESSAGE_TEMPLATES_LIST:${SHORT_MESSAGE_TEMPLATES_LIST.SHORT_MESSAGE_TITLE.key}`,
                    SHORT_MESSAGE_TEMPLATES_LIST.SHORT_MESSAGE_TITLE.value,
                  )
                : t(
                    DOCUMENT_TEMPLATES_LIST.DOCUMENT_TITLE.key,
                    DOCUMENT_TEMPLATES_LIST.DOCUMENT_TITLE.value,
                  )}
            </p>
            {!isPublishedList && (
              <p className={'template_desc'}>
                {isMasterContent
                  ? t(
                      DOCUMENT_TEMPLATES_LIST.DESIGN_INSPIRATION_DESCRIPTION.key,
                      DOCUMENT_TEMPLATES_LIST.DESIGN_INSPIRATION_DESCRIPTION.value,
                    )
                  : isEmailContent
                  ? t(
                      `EMAIL_TEMPLATES_LIST:${EMAIL_TEMPLATES_LIST.EMAIL_DESCRIPTION.key}`,
                      EMAIL_TEMPLATES_LIST.EMAIL_DESCRIPTION.value,
                    )
                  : isShortMessageContent
                  ? t(
                      `SHORT_MESSAGE_TEMPLATES_LIST:${SHORT_MESSAGE_TEMPLATES_LIST.SHORT_MESSAGE_DESCRIPTION.key}`,
                      SHORT_MESSAGE_TEMPLATES_LIST.SHORT_MESSAGE_DESCRIPTION.value,
                    )
                  : t(
                      DOCUMENT_TEMPLATES_LIST.DOCUMENT_DESCRIPTION.key,
                      DOCUMENT_TEMPLATES_LIST.DOCUMENT_DESCRIPTION.value,
                    )}
              </p>
            )}
          </TemplateTitleSec>
        )}
        {!isPublishedList && (
          <>
            {isMasterContent ? (
              <ActiveContent isMaster={true} isPublishedTemp={isPublishedList}>
                <ContentType
                  onClick={() => changeActiveContent('Docs')}
                  isPublishedTemp={isPublishedList}
                >
                  <div className={activeContent === 'Docs' ? 'switch' : 'switch_searchBar'} />
                  <label for="toggle" className="toggleWrapper">
                    <div className="toggle"></div>
                    <div className="text">
                      {t(
                        DOCUMENT_TEMPLATES_LIST.DOCUMENT_TITLE.key,
                        DOCUMENT_TEMPLATES_LIST.DOCUMENT_TITLE.value,
                      )}
                    </div>
                  </label>

                  <div className="background"></div>
                </ContentType>
                {ENABLE_EMAIL_DESIGNS && !isPublishedList && (
                  <ContentType onClick={() => changeActiveContent('MasterMailDocs')}>
                    <div
                      className={activeContent === 'MasterMailDocs' ? 'switch' : 'switch_searchBar'}
                    />
                    <label for="toggle" className="toggleWrapper">
                      <div className="toggle"></div>
                      <div className="text">
                        {t(
                          `EMAIL_TEMPLATES_LIST:${EMAIL_TEMPLATES_LIST.EMAIL_TITLE.key}`,
                          EMAIL_TEMPLATES_LIST.EMAIL_TITLE.value,
                        )}
                      </div>
                    </label>

                    <div className="background"></div>
                  </ContentType>
                )}
              </ActiveContent>
            ) : (
              <ActiveContent isMaster={checkUserAccess('master') && true}>
                {!isShortMessageContent && checkUserAccessRoles(['DESIGNER', 'PUBLISHER']) && (
                  <ContentType>
                    <Tooltip
                      placement="top"
                      title={
                        isEmailContent
                          ? t(
                              `EMAIL_TEMPLATES_LIST:${EMAIL_TEMPLATES_LIST.ADD_NEW_EMAIL_TOOLTIP.key}`,
                              EMAIL_TEMPLATES_LIST.ADD_NEW_EMAIL_TOOLTIP.value,
                            )
                          : t(
                              DOCUMENT_TEMPLATES_LIST.ADD_NEW_DOCUMENT_TOOLTIP.key,
                              DOCUMENT_TEMPLATES_LIST.ADD_NEW_DOCUMENT_TOOLTIP.value,
                            )
                      }
                    >
                      { isCheckingLimit ?
                        <Icon type='loading' />
                      : <Icon
                        type="plus"
                        onClick={() => {
                          if(!isEmailContent) {
                            handleCreateDocTemplate();
                          } else {
                            enableModalVisibility('create-email-template', null);
                          }
                        }}
                      />}
                    </Tooltip>
                    <div onClick={() => changeActiveContent('Docs')}>
                      <div className={activeContent === 'Docs' ? 'switch' : 'switch_searchBar'} />
                      <label for="toggle" className="toggleWrapper">
                        <div className="toggle"></div>
                        <div className="text">
                          {isEmailContent
                            ? t(
                                `EMAIL_TEMPLATES_LIST:${EMAIL_TEMPLATES_LIST.EMAIL_TITLE.key}`,
                                EMAIL_TEMPLATES_LIST.EMAIL_TITLE.value,
                              )
                            : t(
                                DOCUMENT_TEMPLATES_LIST.DOCUMENT_TITLE.key,
                                DOCUMENT_TEMPLATES_LIST.DOCUMENT_TITLE.value,
                              )}
                        </div>
                      </label>
                      <div className="background"></div>
                    </div>
                  </ContentType>
                )}
                {isShortMessageContent && (
                  <ContentType>
                    <Tooltip placement="top" title={t(
                      `SHORT_MESSAGE_TEMPLATES_LIST:${SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_WHATSAPP_MESSAGE_TOOLTIP.key}`,
                      SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_WHATSAPP_MESSAGE_TOOLTIP.value,
                    )}>
                      <Icon
                        type="plus"
                        onClick={() => enableModalVisibility('create-template', 'whats-app')}
                      />
                    </Tooltip>
                    <div onClick={() => changeActiveContent('whatsapp')}>
                      <div
                        className={activeContent === 'whatsapp' ? 'switch' : 'switch_searchBar'}
                      />
                      <label for="toggle" className="toggleWrapper">
                        <div className="toggle"></div>
                        <div className="text">
                          {t(
                            `SHORT_MESSAGE_TEMPLATES_LIST:${SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_WHATSAPP_BUTTON_TEXT.key}`,
                            SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_WHATSAPP_BUTTON_TEXT.value,
                          )}
                        </div>
                      </label>
                      <div className="background"></div>
                    </div>
                  </ContentType>
                )}
                {isShortMessageContent && (
                  <ContentType>
                    <Tooltip placement="top" title={t(
                      `SHORT_MESSAGE_TEMPLATES_LIST:${SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_SMS_MESSAGE_TOOLTIP.key}`,
                      SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_SMS_MESSAGE_TOOLTIP.value,
                    )}>
                      <Icon
                        type="plus"
                        onClick={() => enableModalVisibility('create-template', 'sms')}
                      />
                    </Tooltip>
                    <div onClick={() => changeActiveContent('sms')}>
                      <div className={activeContent === 'sms' ? 'switch' : 'switch_searchBar'} />
                      <label for="toggle" className="toggleWrapper">
                        <div className="toggle"></div>
                        <div className="text">
                          {t(
                            `SHORT_MESSAGE_TEMPLATES_LIST:${SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_SMS_TOOLTIP.key}`,
                            SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_SMS_TOOLTIP.value,
                          )}
                        </div>
                      </label>
                      <div className="background"></div>
                    </div>
                  </ContentType>
                )}
                {isShortMessageContent && (
                  <ContentType>
                    <Tooltip placement="top" title={t(
                      `SHORT_MESSAGE_TEMPLATES_LIST:${SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_CALL_MESSAGE_TOOLTIP.key}`,
                      SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_CALL_MESSAGE_TOOLTIP.value,
                    )}>
                      <Icon
                        type="plus"
                        onClick={() => enableModalVisibility('create-template', 'call')}
                      />
                    </Tooltip>
                    <div onClick={() => changeActiveContent('call')}>
                      <div className={activeContent === 'call' ? 'switch' : 'switch_searchBar'} />
                      <label for="toggle" className="toggleWrapper">
                        <div className="toggle"></div>
                        <div className="text">
                          {t(
                            `SHORT_MESSAGE_TEMPLATES_LIST:${SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_VOICE_MESSAGE_TOOLTIP.key}`,
                            SHORT_MESSAGE_TEMPLATES_LIST.ADD_NEW_VOICE_MESSAGE_TOOLTIP.value,
                          )}
                        </div>
                      </label>
                      <div className="background"></div>
                    </div>
                  </ContentType>
                )}
                 
                 {/* createFlow */}
                {!isShortMessageContent  &&  isDocumentContent &&  (
                  <ContentType>
                    {checkUserAccessRoles(['REUSABLECONTENTMANAGER']) && <Tooltip
                      placement="top"
                      title={t(
                        `REUSABLE_PAGE_DESIGN:${REUSABLE_PAGE_DESIGN.ADD_NEW_REUSABLE_PAGE_TOOLTIP.key}`,
                        REUSABLE_PAGE_DESIGN.ADD_NEW_REUSABLE_PAGE_TOOLTIP.value,
                      )}
                    >
                      <Icon
                        type="plus"
                        onClick={() => {
                          if(isSaasSetupFailed) 
                            setShowSetupFailureError(true);
                          else
                            enableModalVisibility('createFlow', null);
                        }}
                      />
                    </Tooltip>}
                    <div onClick={() => changeActiveContent('createFlow')}>
                      <div
                        className={activeContent === 'createFlow' ? 'switch' : 'switch_searchBar'}
                      />
                      <label for="toggle" className="toggleWrapper">
                        <div className="toggle"></div>
                          <div className="text">
                            {t(
                              `REUSABLE_PAGE_DESIGN:${REUSABLE_PAGE_DESIGN.REUSABLE_PAGE_BUTTON.key}`,
                              REUSABLE_PAGE_DESIGN.REUSABLE_PAGE_BUTTON.value,
                            )}
                          </div>
                      </label>
                      <div className="background"></div>
                    </div>
                  </ContentType>
                )}

                {!isShortMessageContent && isDocumentContent &&(
                  <ContentType>
                    {checkUserAccessRoles(['REUSABLECONTENTMANAGER']) && <Tooltip
                      placement="top"
                      title={t(
                        `REUSABLE_SECTION_DESIGN:${REUSABLE_SECTION_DESIGN.ADD_NEW_REUSABLE_SECTION_TOOLTIP.key}`,
                        REUSABLE_SECTION_DESIGN.ADD_NEW_REUSABLE_SECTION_TOOLTIP.value,
                      )}
                    >
                      <Icon
                        type="plus"
                        onClick={() => {
                          if(isSaasSetupFailed) 
                            setShowSetupFailureError(true);
                          else
                            enableModalVisibility('createBlock', null);
                        }}
                      />
                    </Tooltip>}
                    <div onClick={() => changeActiveContent('createBlock')}>
                      <div
                        className={activeContent === 'createBlock' ? 'switch' : 'switch_searchBar'}
                      />
                      <label for="toggle" className="toggleWrapper">
                        <div className="toggle"></div>
                        <div className="text">
                        {t(
                            `REUSABLE_SECTION_DESIGN:${REUSABLE_SECTION_DESIGN.REUSABLE_SECTION_BUTTON.key}`,
                            REUSABLE_SECTION_DESIGN.REUSABLE_SECTION_BUTTON.value,
                          )}
                        </div>
                      </label>
                      <div className="background"></div>
                    </div>
                  </ContentType>
                )}  

                {!isShortMessageContent && !isDocumentContent && (
                  <ContentType>
                    <Tooltip
                      placement="top"
                      title={t(
                        `DOCUMENT_AND_EMAIL_ELEMENTS_LIST:${DOCUMENT_AND_EMAIL_ELEMENTS_LIST.ADD_NEW_REUSABLE_ELEMENT_TOOLTIP.key}`,
                        DOCUMENT_AND_EMAIL_ELEMENTS_LIST.ADD_NEW_REUSABLE_ELEMENT_TOOLTIP.value,
                      )}
                    >
                      <Icon
                        type="plus"
                        onClick={() => enableModalVisibility('create-element', null)}
                      />
                    </Tooltip>
                    <div onClick={() => changeActiveContent('Reusable')}>
                      <div
                        className={activeContent === 'Reusable' ? 'switch' : 'switch_searchBar'}
                      />
                      <label for="toggle" className="toggleWrapper">
                        <div className="toggle"></div>
                        <div className="text">
                          {t(
                            `DOCUMENT_AND_EMAIL_ELEMENTS_LIST:${DOCUMENT_AND_EMAIL_ELEMENTS_LIST.REUSABLE_ELEMENT_TITLE.key}`,
                            DOCUMENT_AND_EMAIL_ELEMENTS_LIST.REUSABLE_ELEMENT_TITLE.value,
                          )}
                        </div>
                      </label>
                      <div className="background"></div>
                    </div>
                  </ContentType>
                )}
                {checkUserAccess('client') && !isShortMessageContent && !isDocumentContent  &&(
                  <ContentType>
                    <Tooltip
                      placement="top"
                      title={t(
                        `DOCUMENT_AND_EMAIL_ELEMENTS_LIST:${DOCUMENT_AND_EMAIL_ELEMENTS_LIST.ADD_NEW_REFERENCED_ELEMENT_TOOLTIP.key}`,
                        DOCUMENT_AND_EMAIL_ELEMENTS_LIST.ADD_NEW_REFERENCED_ELEMENT_TOOLTIP.value,
                      )}
                    >
                      <Icon
                        type="plus"
                        onClick={() => enableModalVisibility('create-ref-element', null)}
                      />
                    </Tooltip>
                    <div onClick={() => changeActiveContent('Referenced')}>
                      <div
                        className={activeContent === 'Referenced' ? 'switch' : 'switch_searchBar'}
                      />
                      <label for="toggle" className="toggleWrapper">
                        <div className="toggle"></div>
                        <div className="text">
                          {t(
                            `DOCUMENT_AND_EMAIL_ELEMENTS_LIST:${DOCUMENT_AND_EMAIL_ELEMENTS_LIST.REFERENCED_ELEMENT_TITLE.key}`,
                            DOCUMENT_AND_EMAIL_ELEMENTS_LIST.REFERENCED_ELEMENT_TITLE.value,
                          )}
                        </div>
                      </label>
                      <div className="background"></div>
                    </div>
                  </ContentType>
                )}
              </ActiveContent>
            )}
          </>
        )}
        { selectedAction === 'createFlow' &&         
          <CreateFlowModal
          onSucess={redirectToFlow}
          onCancel={disableModalVisibility}
          // visible={updateModalVisibility}
          />
        }
        {
          selectedAction === 'createBlock' &&         
          <CreateBlockModal
          onSucess={redirectToBlock}
          onCancel={disableModalVisibility}
          />
        }

        {activeContent === 'Docs' || activeContent === 'MasterMailDocs' ? (
          <>
            {isEmailContent ? (
              <EmailTemplateSection
                mailCategoryList={categoryList}
                forApproval={forApproval}
                deteteTemplate={e => setIsTemplateDeleted(e)}
              />
            ) : isMasterContent ? (
              <MasterTempSection
                userpage={userpage}
                isMailTemplates={activeContent === 'MasterMailDocs'}
                tempCategories={categoryList}
              />
            ) : isPublishedList ? (
              isPublishedTemp? (
                <GeneratePdf page={userpage}
                tempCategories={categoryList}
                filterByCateg={filterCateg}
                searchVal={globalSearchVal}
                searchTag={globalSearchTag}
                onTempSelection={e => setCurrentUploadStep(e)}/>
              ): (
                <PublishedTemplates
                  page={userpage}
                  isMailTemplates={isEmailPublishedTemp}
                  isPublishedMessages={isPublishedMessages}
                  publishedMessageType={isPublishedMessages ? props.location?.pathname : ''}
                  tempCategories={categoryList}
                  filterByCateg={filterCateg}
                  searchVal={globalSearchVal}
                  searchTag={globalSearchTag}
                  ClearALLInputs={isClearALLInputs}
                  onTempSelection={e => setCurrentUploadStep(e)}
                />
              )
            ) : (
              <DocTemplateSection
                tempCategories={categoryList}
                languageList={languageList}
                deteteTemplate={e => setIsTemplateDeleted(e)}
              />
            )}
          </>
        ) : isShortMessageContent ? (
          <ShortMessageTemplateSection
            tempCategories={categoryList}
            activeContent={activeContent}
            deteteTemplate={e => setIsTemplateDeleted(e)}
            languageList={languageList}
          />
        ) : (
          <ReferenceElements
            isEmailElements={isEmailContent}
            isReferenced={activeContent === 'Referenced'}
            userpage={userpage}
            activeContent={activeContent}
            activeTab={filterCateg}
            globalSearchVal={globalSearchVal}
            globalSearchTag={globalSearchTag}
            elementCategories={categoryList}
            forApproval={forApproval}
          />
        )}
        {selectedAction === 'create-template' ? (
          updateModalVisibility && isShortMessageContent ? (
            <CreateShortMsgTempModal
              templateType={selectedTemplate}
              visible={updateModalVisibility}
              onCancel={disableModalVisibility}
              onSucess={redirectToShortMessageTemplate}
              activeContent={selectedTemplate}
              categoryType="template"
            />
          ) : (
            <CreateTemplateModal
              visible={updateModalVisibility}
              onCancel={disableModalVisibility}
              onSucess={redirectToTemplate}
              categoryType="template"
            />
          )
        ) : selectedAction === 'create-ref-element' || selectedAction === 'create-element' ? (
          elementmodalVisibility && (
            <CreateNewRefElement
              visible={elementmodalVisibility}
              onCancel={disableModalVisibility}
              // onSucess={redirectToRefElement}
              categoryType="template"
              isEmailElements={isEmailContent}
              isReferenced={selectedAction === 'create-ref-element' ? true : false}
            />
          )
        ) : selectedAction === 'create-email-template' ? (
          updateModalVisibility && (
            <CreateMailTemplateModal
              visible={updateModalVisibility}
              onCancel={disableModalVisibility}
              onSucess={redirectToMailTemplate}
              categoryType="template"
            />
          )
        ) : (
          ''
        )}
      </Container>
      {isScrollToTop && (
        <Tooltip placement="left" title={'Scroll to top'}>
          <Icon type="arrow-up" onClick={() => smoothScroll()} />
        </Tooltip>
      )}
      <UpgradePlanModal 
        visible={showUpgradeModal}
        modalText={
          planName === 'Premium' ?
            t(CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.key, CREATE_NEW_TEMPLATE_MODAL.PREMIUM_DOCUMENT_CREATION_LIMIT_EXCEEDED.value, { emailId: SUPPORT_EMAIL_ID })
          : planName === 'Free' ? t(CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.FREE_PLAN_UPGRADE_MESSAGE.value, { documentLimit }) 
          : t(CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.key, CREATE_NEW_TEMPLATE_MODAL.STANDARD_PLAN_UPGRADE_MESSAGE.value, { documentLimit })
        }
        onCancel={() => setShowUpgradeModal(false)}
      />
      <SetupErrorModal
        showError={showSetupFailureError}
        setShowError={setShowSetupFailureError} />
    </ScrollContainer>
  );
};

export default withTranslation(NAMESPACES)(TemplateSection);
